
import BpmnModeler from 'bpmn-js/lib/Modeler';
import { useEffect, useRef } from "react";
import { useInput } from 'react-admin';
import XML_INITIAL from "./BpmnInitial";
import ExtendsModule from "./extends";

const BpmnInput = (props) => {
    const {
        input: { onChange, value }
    } = useInput(props);
    const containerRef = useRef();
    useEffect(() => {
        const bpmn = new BpmnModeler({
            container: containerRef.current,
            additionalModules: [
                ExtendsModule
            ]
        });
        bpmn.on('commandStack.changed', () => {
            bpmn.saveXML().then(result => {
                onChange(result.xml);
            });
        });
        if (value) {
            bpmn.importXML(value);
        } else {
            onChange(XML_INITIAL)
        }
        return () => {
            bpmn.destroy();
        };
    }, [onChange, value]);

    return <div className="bpmn-container modeler" ref={containerRef}></div>
};

export default BpmnInput;


